import { render, staticRenderFns } from "./Offre.vue?vue&type=template&id=00198f95"
import script from "./Offre.vue?vue&type=script&lang=js"
export * from "./Offre.vue?vue&type=script&lang=js"
import style0 from "./Offre.vue?vue&type=style&index=0&id=00198f95&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports